/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { DataFieldRef, MapString, MeetingTypeUpdate, MeetingTypeWithReminders } from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V2<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "meeting-types";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Updates meeting type for the specified id
   *
   * @tags Meeting Type / CRUD
   * @name UpdateMeetingType
   * @request PUT:/v2/tenant/{tenantId}/workspace/{workspaceId}/meeting-type/{meetingTypeId}
   * @secure
   */
  updateMeetingType = (
    tenantId: string,
    workspaceId: string,
    meetingTypeId: string,
    data: MeetingTypeUpdate,
    params: RequestParams = {},
  ) =>
    this.request<
      MeetingTypeWithReminders,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/workspace/${workspaceId}/meeting-type/${meetingTypeId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateMeetingType */
  updateMeetingTypePathGetter = (tenantId: string, workspaceId: string, meetingTypeId: string) =>
    this.getServicePath(`/v2/tenant/${tenantId}/workspace/${workspaceId}/meeting-type/${meetingTypeId}`);
}
